import React, { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { useInjector } from 'utils/inject';

import { DataPolicyComponent } from './Components/DataPolicyComponent';
import { CreateDataPolicy } from './Components/DataPolicyWizard/CreateDataPolicy';
import { EditDataPolicy } from './Components/DataPolicyWizard/EditDataPolicy';
import { maskingPoliciesSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const MaskingPolicies = memo(() => {
  useInjector(sliceKey, reducer, maskingPoliciesSaga);

  return (
    <ActiveResourceProvider>
      <Routes>
        <Route path="add" element={<CreateDataPolicy />} />
        <Route path="edit/:id" element={<EditDataPolicy />} />
        <Route
          index
          element={<DataPolicyComponent basePath="/jit/data/policy" />}
        />
      </Routes>
    </ActiveResourceProvider>
  );
});
